"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdpServerServiceNS = void 0;
var IdpServerServiceNS;
(function (IdpServerServiceNS) {
    IdpServerServiceNS.IDP_SERVER_SERVICE_ID = Symbol.for("IdpServerService");
})(IdpServerServiceNS = exports.IdpServerServiceNS || (exports.IdpServerServiceNS = {}));
//# sourceMappingURL=idp-server.types.js.map